module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": (_vm.device == 'xs' ? '97%' : _vm.width),
      "close-on-press-escape": _vm.closeESC,
      "close-on-click-modal": _vm.closeCLICK,
      "modal": _vm.isModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": _vm.handlerClose
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.toUpperCase()) + "\n    ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.onSave && !_vm.isCurrentTabHistorico) ? _c('ed-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave,
      "disabled": _vm.disabledSave,
      "icon": _vm.saveIcon,
      "value": _vm.saveName
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onClear) ? _c('ed-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-refresh",
      "value": "Limpar"
    },
    on: {
      "click": _vm.onClear
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-window-close",
      "value": "Fechar"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10fb0886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/modal.vue
// module id = 1448
// module chunks = 45